import React from 'react';
import PropTypes from 'prop-types';
import {get as _get, isEmpty as _isEmpty} from 'lodash';

import {Competitors} from '@modules/events/components/EventsTabsLayout/Details/EventDetails/column3/Competitors';
import {venueCourtLabel, venueCourtValue} from '@utils/venue';
import { getTvChannelNamesFromEvent } from '@utils/tvChannels';
import {stageName} from '@modules/events/utils/EventsTabsLayout/Details/EventDetails/fields/column3/stageName';

export const isNotStageEvent = (event) => {
    return !!event.av_event || !!event.sr_event;
};

export const getFieldsList = (event) => {
    const fieldsColumn = [];

    if (isNotStageEvent(event)) {
        fieldsColumn.push({
            name: 'Competitors',
            value: <Competitors event={event}/>,
        });
    } else {
        fieldsColumn.push({
            name: 'Name',
            value: stageName(event),
        });
    }

    fieldsColumn.push({
        name: venueCourtLabel(event),
        value: venueCourtValue(event),
    });

    // Display label if sport supports TV Channel - even if particular match doesn't have assigned TV channels
    if (_get(event, 'property_licence.sport.has_tv_channel', false)) {
        fieldsColumn.push({
            name: 'TV channel',
            value: getTvChannelNamesFromEvent(event),
        });
    }

    fieldsColumn.push(
        {
            name: 'Description',
            value: event.description || '-',
        }
    );

    if (!_isEmpty(event?.external_description)) {
        fieldsColumn.push(
            {
                name: 'Ext. description',
                value: event.external_description,
            }
        );
    }

    return fieldsColumn;
};

getFieldsList.propTypes = {
    event: PropTypes.shape({
        description: PropTypes.string,
        external_description: PropTypes.string,
    }).isRequired,
};

getFieldsList.defaultProps = {
    event: {
        description: null,
    },
};
